/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_Previous_SessionsInputs */

const en_interview_prepare_previous_sessions = /** @type {(inputs: Interview_Prepare_Previous_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous Sessions`)
};

const de_interview_prepare_previous_sessions = /** @type {(inputs: Interview_Prepare_Previous_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige Sitzungen`)
};

const fr_interview_prepare_previous_sessions = /** @type {(inputs: Interview_Prepare_Previous_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions précédentes`)
};

const es_interview_prepare_previous_sessions = /** @type {(inputs: Interview_Prepare_Previous_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesiones anteriores`)
};

const it_interview_prepare_previous_sessions = /** @type {(inputs: Interview_Prepare_Previous_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessioni precedenti`)
};

const nl_interview_prepare_previous_sessions = /** @type {(inputs: Interview_Prepare_Previous_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorige sessies`)
};

const pl_interview_prepare_previous_sessions = /** @type {(inputs: Interview_Prepare_Previous_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzednie sesje`)
};

const fi_interview_prepare_previous_sessions = /** @type {(inputs: Interview_Prepare_Previous_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aiemmat istunnot`)
};

const da_interview_prepare_previous_sessions = /** @type {(inputs: Interview_Prepare_Previous_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidligere sessioner`)
};

const sv_interview_prepare_previous_sessions = /** @type {(inputs: Interview_Prepare_Previous_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidigare sessioner`)
};

/**
* | output |
* | --- |
* | "Previous Sessions" |
*
* @param {Interview_Prepare_Previous_SessionsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_previous_sessions = /** @type {((inputs?: Interview_Prepare_Previous_SessionsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Previous_SessionsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_previous_sessions(inputs)
	if (locale === "fr") return fr_interview_prepare_previous_sessions(inputs)
	if (locale === "es") return es_interview_prepare_previous_sessions(inputs)
	if (locale === "it") return it_interview_prepare_previous_sessions(inputs)
	if (locale === "nl") return nl_interview_prepare_previous_sessions(inputs)
	if (locale === "pl") return pl_interview_prepare_previous_sessions(inputs)
	if (locale === "fi") return fi_interview_prepare_previous_sessions(inputs)
	if (locale === "da") return da_interview_prepare_previous_sessions(inputs)
	if (locale === "sv") return sv_interview_prepare_previous_sessions(inputs)
	return en_interview_prepare_previous_sessions(inputs)
});